import i18n from '../VueI18n'

/**
 *
 * @param {Object} categoriaDeFitossanidade Categoria de Fitossanidade que deve ser validada
 * @param {Array<Object>} categoriasDeFitossanidade Lista de categorias de arvores que devem ser usados para validacao
 */
const validarCategoriaDeFitossanidade = (categoriaDeFitossanidade, categoriasDeFitossanidade) => {
	if (!isUnique(categoriaDeFitossanidade, categoriasDeFitossanidade)) {
		return {
			isValid: false,
			message: `${i18n.t('aCategoriaDeFitossanidade')} "${categoriaDeFitossanidade.nome}" ${i18n.t('jaEstaCadastradaNoSistema')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se a categoria de árvore possui valores unicos considerando:
 * - nome
 * @param {Object}  categoriaDeFitossanidade que deve ser validado
 * @param {Array<Object>} categoriasDeFitossanidade Lista de parcelas que devem ser usados para validacao
 */
function isUnique(categoriaDeFitossanidade, categoriasDeFitossanidade) {
	return (
		categoriasDeFitossanidade.filter(
			(categoriaDeFitossanidadeDaLista) =>
				categoriaDeFitossanidadeDaLista.nome.toLowerCase() ===
				categoriaDeFitossanidade.nome.toLowerCase(),
		).length === 0
	)
}

export default validarCategoriaDeFitossanidade
